<template lang="pug">
.professional-picker.flex.align-center.justify-stretch
  template(v-if="useGroup")
    el-select.flex-1(
      v-model="localValue",
      filterable, clearable,
      placeholder="請選擇專業人士", @change="handleSelect")
      el-option(v-if="showAll", label="全部", value="")
      template(v-for="group in groupedValue")
        el-option-group(:label="group.branch.name", :key="group.branch.id")
          el-option(v-for="opt in group.professionals", :key="opt.id", :label="opt.label", :value="opt.id")
  template(v-else)
    el-select.flex-1(
      v-model="localValue",
      filterable, clearable,
      placeholder="請選擇專業人士", @change="handleSelect")
      el-option(v-if="showAll", label="全部", value="")
      el-option(v-for="opt in options", :key="opt.id", :label="opt.label", :value="opt.id")
</template>

<script>
import { getProfessionalList } from '@/api/professionals';
import { getBranches } from '@/api/place';

const NO_BRANCH = { id: 'none', name: '未登記館別' };

export default {
  name: 'pro-selector',
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    value: {
      required: true,
    },
    showAll: {
      type: Boolean,
      default: false,
    },
    publicOnly: {
      type: Boolean,
      default: false,
    },
    useGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: undefined,
      options: undefined,

      branches: [],
    };
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
  computed: {
    // 依專業人士的第一個登記館別分組。館別來自專業人士資料本身，
    // 因為 GET /v1/branches 對有指定館別的後台帳號只回自己的館別，只用它分組會漏掉其他館別的專業人士；
    // 它只用來排序（公開館別在前），不在其中的館別依 id 排在後面，沒有登記館別的歸到最後一組
    groupedValue() {
      if (!this.useGroup) {
        return [];
      }
      const order = {};
      this.branches.forEach((b, index) => {
        order[b.id] = index;
      });
      const groupMap = {};
      (this.options || []).forEach((p) => {
        const branch = p.branch || NO_BRANCH;
        if (!groupMap[branch.id]) {
          groupMap[branch.id] = { branch, professionals: [] };
        }
        groupMap[branch.id].professionals.push(p);
      });
      const rank = (g) => {
        if (g.branch === NO_BRANCH) return [2, 0];
        if (order[g.branch.id] !== undefined) return [0, order[g.branch.id]];
        return [1, g.branch.id];
      };
      return Object.values(groupMap).sort((a, b) => {
        const [ra, rb] = [rank(a), rank(b)];
        return ra[0] - rb[0] || ra[1] - rb[1];
      });
    },
  },
  methods: {
    handleSelect(professional) {
      this.$emit('input', professional);
    },
    async loadData() {
      // 館別只用於分組排序，失敗不影響選單
      this.branches = this.useGroup ? await getBranches().catch(() => []) : [];
      const data = await getProfessionalList();
      const options = data.map((p) => ({
        ...p,
        label: `${p.family_name}${p.given_name}`,
        branch: p.branches[0],
      })).filter((p) => !this.publicOnly || p.public);
      options.sort((a, b) => a.label.localeCompare(b.label, 'zh-Hant'));
      this.options = options;
    },
  },
  mounted() {
    this.loadData();
    if (this.showAll) {
      this.localValue = '';
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
